// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Segment } from 'semantic-ui-react';
// local
// views
// actions
import { closeSaveUpdate, ACTION } from 'app/redux/actions/modal/save-update-modal.action';
import Notification from 'app/components/commons/notification/Notification';
import DefaultButton from 'app/components/commons/button/defaultButton/DefaultButton';
// consts
import { COLORS } from 'app/config/colors';
//import './SaveUpdateNewModal.scss';
import styles from './SaveUpdateNewModal.module.scss';

// REFACTOR Realizar refatoração a fim de eliminar o SaveUpdateNewModal e utilizar o SaveUpdateModal
// EXPLANATION Essa refatoração consistirá em utilizar o componente SaveUpdateNewModal com o nome SaveUpdateModal e realizar sua sustituição em todo o sistema.

class SaveUpdateNewModal extends Component {
  componentWillUnmount = () => this.onClose();

  onClose = () => {
    this.props.options.dispatch(closeSaveUpdate());
  };

  onSubmit = () => {
    const { onConfirmModal, action } = this.props.options;
    if (onConfirmModal && onConfirmModal(action)) {
      this.onClose();
    }
  };

  render() {
    const { /* id, */ children, options } = this.props;
    const {
      isOpened,
      action,
      title,
      error,
      loading,
      size = 'tiny',
      disableConfirmationButton = false
    } = options;

    let actionTerm = '';

    if (action === ACTION.ADD) {
      actionTerm = 'ADICIONAR';
    } else if (action === ACTION.UPDATE) {
      actionTerm = 'ATUALIZAR';
    } else {
      actionTerm = 'IMPORTAR';
    }

    let tagConfirmation = null;

    if (action === ACTION.IMPORT) {
      tagConfirmation = 'Importar';
    } else if (action === ACTION.ADD) {
      tagConfirmation = 'Adicionar';
    } else if (action === ACTION.UPDATE) {
      tagConfirmation = 'Salvar';
    }
    return (
      <Modal
        //id={id}
        id={styles.modal}
        open={isOpened}
        onClose={this.onClose}
        closeOnDimmerClick={false}
        size={size}
        style={{ borderRadius: '14px' }}
      >
        <Modal.Header style={{ textAlign: 'flex-start' }}>
          {actionTerm} {title}
        </Modal.Header>
        <Segment vertical loading={loading}>
          {error ? <Notification message={error.errors} isError /> : null}
          <Modal.Content className={styles.content}>{children}</Modal.Content>

          <Modal.Actions className={styles.actions}>
            <DefaultButton
              tag={'Cancelar'}
              onClick={this.onClose}
              backgroundColor={COLORS.WHITE_VARIANT}
              backgroundColorHover={COLORS.SECONDARY_VARIANT}
              borderColor={COLORS.SECONDARY_VARIANT}
              color={COLORS.PRIMARY_VARIANT}
              colorHover={COLORS.PRIMARY_VARIANT}
              borderColorHover={COLORS.SECONDARY_VARIANT}
            />

            <DefaultButton
              tag={tagConfirmation}
              onClick={this.onSubmit}
              disabled={disableConfirmationButton}
              backgroundColor={COLORS.ACCENTUATED_VARIANT}
              borderColor={COLORS.ACCENTUATED_VARIANT}
              color={COLORS.WHITE_VARIANT}
              colorHover={COLORS.WHITE_VARIANT}
              backgroundColorHover={COLORS.ACCENTUATED_VARIANT_DARK}
              borderColorHover={COLORS.ACCENTUATED_VARIANT}
            />
          </Modal.Actions>
        </Segment>
      </Modal>
    );
  }
}

SaveUpdateNewModal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  options: PropTypes.object
};

export default SaveUpdateNewModal;
